export default "__VITE_ASSET__AoYnvE$6__"